import { Avatar, Stack, Typography } from '@mui/material'
import { GetRosterCandidateForClientProfileQuery } from '__generated__/graphql'
import { LoadingPanel } from 'shared/components/LoadingPanel'
import { getInitials, getPxAsRem } from 'shared/utils'
import CandidateDetailDataPoints from './CandidateDetailDataPoints'

interface CandidateDetailsProps {
    data: GetRosterCandidateForClientProfileQuery | null
}

export default function CandidateDetails(props: CandidateDetailsProps) {
    const { data } = props

    if (!data) {
        return <LoadingPanel />
    }

    const candidate = data?.rosterCandidate?.candidate

    return (
        <Stack
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                gap: getPxAsRem(8),
            }}
        >
            <Avatar
                src={
                    candidate?.user?.profileImageKey ||
                    candidate?.internalProfileImageKey ||
                    ''
                }
                sx={{
                    width: getPxAsRem(134),
                    height: getPxAsRem(134),
                    fontSize: '3rem',
                }}
            >
                {getInitials({
                    firstName: candidate?.user?.firstName,
                    nickname: candidate?.user?.nickname,
                    lastName: candidate?.user?.lastName,
                })}
            </Avatar>

            <Stack
                sx={{
                    flexGrow: 1,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    gap: getPxAsRem(4),
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        paddingLeft: getPxAsRem(24),
                    }}
                >
                    {candidate?.user?.nickname ?? candidate?.user?.firstName}{' '}
                    {candidate?.user?.lastName}
                </Typography>
                <CandidateDetailDataPoints data={data} />
            </Stack>
        </Stack>
    )
}
